import { createFileRoute } from '@tanstack/react-router';
import { SpaceInvitePage } from '@/components/spaces/SpaceInvitePage';

export const Route = createFileRoute('/invite/$token')({
  component: RouteComponent,
  head: () => ({
    meta: [
      {
        title: 'Findya | Space invitation',
      },
    ],
  }),
});

function RouteComponent() {
  const { token } = Route.useParams();
  return <SpaceInvitePage token={token} />;
}
